module.exports = __webpack_public_path__ + "assets/img/samplePicture.838efbca.png";